/*! @azure/msal-common v15.17.0 2026-03-18 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "15.17.0";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
